/* homemodule */
/* globalmodule */
define('../src/sublayouts/m2-hero-image/m2-hero-image',['jquery', 'tooltipster', 'lib/utils'], function($, tooltipster, utils) {

    'use strict';

    /**
     * This module only effects Tabs on desktop. Mobile view uses the toggle helper.
     */

    var m2Hero = function($component) {

        this.$component = $component;

        return this;
    };

    m2Hero.prototype.init = function() {

        this.$component.find('.m2-hero-image__inner').each(function() {
            var text = $(this).attr('data-alt');

            $(this).tooltipster({
                content: text,
                distance: -48,
                maxWidth: 250,
                arrow: true
            });
        });
    };

    return m2Hero;
});

